import { render } from "./footer-watermark-home.vue?vue&type=template&id=185f3e38"
import script from "./footer-watermark-home.vue?vue&type=script&lang=js"
export * from "./footer-watermark-home.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__